const toDate = (value) => {
    if (!value) return null;
    if (typeof value === "number" || /^\d+$/.test(String(value))) {
        return new Date(Number(value) * 1000);
    }
    return new Date(value);
};

const postedOn = (value) => {
    const parsed = toDate(value);
    if (!parsed || Number.isNaN(parsed.getTime())) return "";
    const days = Math.floor((Date.now() - parsed.getTime()) / 86400000);
    if (days <= 0) return "Posted today";
    if (days === 1) return "Posted 1 day ago";
    if (days < 30) return `Posted ${days} days ago`;
    return `Posted ${parsed.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}`;
};

export default postedOn;
